export const SELECT_PLAN_SUCCESS = 'SELECT_PLAN_SUCCESS'
export const SHOW_PLANS = 'SHOW_PLANS'
export const HIDE_PLANS = ' HIDE_PLANS'
export const GO_TO_PAYMENT = ' GO_TO_PAYMENT'
export const SET_SHOW_PAYMENT_FALSE = ' SET_SHOW_PAYMENT_FALSE'
export const SHOW_PLANS_FOR_UPGRADE = ' SHOW_PLANS_FOR_UPGRADE'
export const SHOW_SUBSCRIPTION_DETAILS = ' SHOW_SUBSCRIPTION_DETAILS'
